var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 12,
    viewBox: "0 0 44 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 6C32.6667 8.94552 35.0545 11.3333 38 11.3333C40.9455 11.3333 43.3333 8.94552 43.3333 6C43.3333 3.05448 40.9455 0.666667 38 0.666667C35.0545 0.666667 32.6667 3.05448 32.6667 6ZM0 7H3.16667V5H0V7ZM9.5 7H15.8333V5H9.5V7ZM22.1667 7H28.5V5H22.1667V7ZM34.8333 7H38V5H34.8333V7Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashDot);
export default __webpack_public_path__ + "static/media/dash-dot.594c328672ad6c09cfd7150ffd00e29c.svg";
export { ForwardRef as ReactComponent };